export default __webpack_public_path__ + "static/media/Tasset of the Stormbringer.71f89a52.jpg";